import { Icon as ChakraIcon, IconProps } from '@chakra-ui/react';

export const Icon = ({ path, boxSize, ...props }: IconProps) => {
  return (
    <ChakraIcon {...props} boxSize={boxSize}>
      <path fill="currentColor" d={path} />
    </ChakraIcon>
  );
};
